import { defineMessages } from 'react-intl';

export const messages: {
	switcherAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	switcherAriaLabel: {
		id: 'twg-microsite.footer.brand.languageSwitcher.ariaLabel',
		defaultMessage: 'Change language, currently {language}',
		description:
			'Accessible name for the footer language-switcher dropdown trigger. {language} is the native name of the active locale, e.g. "English", "Deutsch".',
	},
});
